import type { Ceviri } from "../tip";
import type { formul as tr } from "../tr/formul";

/** English dictionary · formul (ⓘ formula balloons). */
export const formul: Ceviri<typeof tr> = {
  piyasaDegeri: {
    ad: "Market value",
    formul: "Quantity held × latest unit price; the price currency is converted to the report currency at that day's exchange rate.",
  },
  pay: {
    ad: "Weight",
    formul: "The asset's value ÷ the value of all assets in the selected scope (whole vault, one account or a virtual account).",
  },
  maliyet: {
    ad: "Cost",
    formul:
      "Purchase amount + purchase fee of the lots still held; each lot is converted at the exchange rate of its own purchase day. Sold lots (FIFO) are deducted.",
  },
  mevcutGetiri: {
    ad: "Unrealised gain (current return)",
    formul:
      "Current return = value of holdings − their cost. Percentage: ÷ money out of pocket (cost − cost of lots bought with dividends).",
    temettuHaric:
      "Current return = value of holdings − their cost. Percentage: ÷ cost. Dividends were excluded by the rule.",
  },
  gerceklesmisKazanc: {
    ad: "Realised gain",
    formul: "Sale gain = sale proceeds − cost of the lots sold (FIFO). Percentage: ÷ cost of the lots sold.",
  },
  nakitAkisi: {
    ad: "Cash flow",
    formul: "Cash flow = dividends + interest − fees. Deposits and withdrawals are not included.",
    temettuHaric: "Cash flow = interest − fees. Dividends were excluded by the rule.",
  },
  gerceklesmisGetiri: {
    ad: "Realised return",
    formul: "Realised return = sale gain + dividends/interest − fees. Percentage: ÷ cost of the lots sold.",
    temettuHaric:
      "Realised return = sale gain + interest − fees. Dividends were excluded by the rule. Percentage: ÷ cost of the lots sold.",
  },
  yillikKarsilik: {
    ad: "Annualised",
    formul:
      "Return rate × 365 ÷ cost-weighted age (days). Return: lifetime; denominator: money out of pocket. Not shown for money younger than 30 days.",
  },
  asilGetiri: {
    ad: "True return",
    formul:
      "True return = today's value (including cash) − (deposited − withdrawn). Percentage: ÷ (deposited − withdrawn). A purchase made with sale proceeds is not new money; the part of a purchase not covered by cash on hand counts as money in. Annualised: money-weighted (each inflow from its own date).",
  },
  gunlukGetiri: {
    ad: "Daily return",
    formul:
      "Daily = today's lifetime return − the previous day's lifetime return. Percentage: ÷ the previous day's value. Amounts bought or sold that day do not enter the difference. For assets in a foreign currency the difference includes the exchange rate change.",
  },
  kesilenVergi: {
    ad: "Withheld tax",
    formul: "Sale withholding + dividend/interest withholding. Not included in the gain.",
  },
  toplamMaliyet: {
    ad: "Total cost",
    formul:
      "Total cost = deposited − withdrawn (net money put in). A purchase made with sale proceeds is not new money; the part of a purchase not covered by cash on hand counts as money in. Each inflow and outflow at its own day's rate.",
  },
  toplamVarlik: {
    ad: "Total assets",
    formul: "Today's value of the assets in the selected scope + cash balance. With cash tracking off, assets only.",
  },
  getiri: {
    ad: "Return",
    formul: "Return = total assets − total cost. Percentage: ÷ total cost.",
  },
  mevduatKarsiligi: {
    ad: "Deposit equivalent",
    formul:
      "Return percentage × 365 ÷ weighted average days (simple, annual). Weighted average days = Σ(each inflow × days it stayed; outflows negative) ÷ total cost. Not shown for less than 30 days.",
  },
};
